import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-elabel-config',
  templateUrl: './elabel-config.component.html',
  styleUrls: ['./elabel-config.component.css']
})
export class ElabelConfigComponent implements OnInit {
  @Input() product: any;

  isElabelActive: boolean = false;
  selectedCategory: string = '';
  
  categories: any[] = [
    { id: '1', name: 'Nông sản, thực phẩm' },
    { id: '2', name: 'Mỹ phẩm' },
    { id: '3', name: 'Đồ điện tử' },
    { id: '4', name: 'Ngành hàng khác' }
  ];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/elabel-config/elabel-config.component.ts